import React from 'react';
import { useLivePlans } from '../lib/useLivePlans';

export function BillingCyclePicker({ value, onChange, testId = 'billing-cycle-picker' }) {
    // Pull live cycles so super-admin discount changes (`/admin/plans/cycle-discount/*`)
    // appear in the picker without needing a redeploy.
    const { cycles: BILLING_CYCLES } = useLivePlans();
    return (
        <div className="billing-cycle-picker-wrap">
            <div
                className="billing-cycle-picker"
                data-testid={testId}
                role="tablist"
                aria-label="Perioadă de plată"
            >
                {BILLING_CYCLES.map((cycle) => {
                    const active = value === cycle.id;
                    const hint = cycle.discountPercent > 0 ? `−${cycle.discountPercent}%` : null;
                    return (
                        <button
                            key={cycle.id}
                            type="button"
                            role="tab"
                            aria-selected={active}
                            className={`billing-cycle-picker__btn${active ? ' billing-cycle-picker__btn--active' : ''}`}
                            onClick={() => onChange(cycle.id)}
                            data-testid={`${testId}-${cycle.id}`}
                        >
                            <span>{cycle.label}</span>
                            {hint && <span className="billing-cycle-picker__hint">{hint}</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
